import { setFocusOnField } from '@/core/core_components/form/form'
import { bindResetButtonModal } from '@/core/input_controls/button/button'
import { countriesListHtml, emailValidation, getLocalizedMessage, showMessageAlert } from '@/core/shared'
import {
	getDataFromBoolean,
	getDataFromList,
	getDataFromTextInput
} from '@/core/item_assistance/receiveDataFromComponents'
import { initDataInBoolean, initDataInList, initDataInTextInput } from '@/core/item_assistance/initializeComponentData'

export function UserManager() {
	'use strict';

	this.action = undefined;
	this.activeAttribute = undefined;
	this.prefix = undefined;
	this.removeButton = undefined;
	this.postSaveAction = undefined;
	this.postRemoveAction = undefined;
	this.user = undefined;
	this.userIds = undefined;
	this.companyId = undefined;
	this.individualPersons = undefined;
	this.groups = {};
	this.userRelations = {};
	this.isNewIndividualPerson = false;

	this.setProperties = function(properties) {
		this.individualPersonsType();
		this.action = properties.action || 'create';
		this.activeAttribute = properties.activeAttribute || undefined;
		this.prefix = properties.prefix || 'user_';
		this.removeButton = properties.removeButton;
		this.postSaveAction = properties.postSaveAction;
		this.postRemoveAction = properties.postRemoveAction;
		this.user = properties.user;
		this.userIds = properties.userIds;
		this.companyId = properties.companyId;
		this.individualPersons = properties.individualPersons;
	};

	this.initRemovePage = function(multipleMode) {
		var manager = this;

		this.userRelations.company = { id: this.companyId };

		this.initLists();

		if (multipleMode) {
			manager.removeUsers();
		} else {
			manager.removeUser();
		}
	};

	this.saveUser = function(action, userInformation) {
		var user = this;

		var url = userInformation.id ? 'user/update' : 'user/create'

		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: JSON.stringify(userInformation),
			contentType: 'application/json; charset=UTF-8',

			success: function () {
				if (user.postSaveAction)
					user.postSaveAction();
				showMessageAlert(getLocalizedMessage("changes.saved"), 'success');
			},
			error: function () {
				showMessageAlert(getLocalizedMessage("error.saving"), 'danger');
			}
		});
	};

	this.removeUser = function() {
		var manager = this;
		var url = 'users/delete';

		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: {ids: JSON.stringify([manager.user.id])},

			success: function () {
				if (manager.postRemoveAction)
					manager.postRemoveAction();
				showMessageAlert(getLocalizedMessage("user.removed"), 'success');
			},
			error: function () {
				showMessageAlert(getLocalizedMessage("error.removing"), 'danger');
			}
		});
	};

	this.removeUsers = function () {
		var user = this;
		var url = 'users/delete';

		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: {ids: JSON.stringify(user.userIds)},

			success: function () {
				if (user.postRemoveAction)
					user.postRemoveAction();
				showMessageAlert(getLocalizedMessage("users.removed"), 'success');
			},
			error: function () {
				showMessageAlert(getLocalizedMessage("users.error.removing"), 'danger');
			}
		});
	};

	this.initLists = function() {
		var user = this;

		if (this.action == 'create') {
			$('#' + this.prefix + 'individualPersons').parent().removeClass('hidden-element');
			this.setListData(this.individualPersons, 'individualPersons', false);

			$('#' + this.prefix + 'individualPersons').change(function() {
				user.setUserRelation('individualPerson', getDataFromList(user.prefix + 'individualPersons'), user.individualPersons);
			});
		} else {
			this.setListData([], 'individualPersons', false);
			$('#' + this.prefix + 'individualPersons').parent().addClass('hidden-element');
		}

		this.loadAndSetUserGroups();
	};

	this.setListData = function(data, field, isName) {
		var list = '';
		$('#' + this.prefix + field).empty();
		_.each(data, function(value) {
			list += "<option value='" + value['id'] + "'>" + (isName ? value['name'] : value['firstName'] + ' ' + value['lastName']) + "</option>";
		});
		$('#' + this.prefix + field).html(list);
	};

	this.getUserInformation = function() {
		var userInformation = {};

		if (this.action == 'edit')
			userInformation['id'] = this.user.id;
		if (this.action == 'remove') {
			userInformation['id'] = this.user.id;
			userInformation['companyId'] = this.companyId;
			userInformation['active'] = false;
		}
		_.each(this.userRelations, function(value, key) {
			if (!_.isEmpty(value))
				userInformation[key + 'Id'] = value.id;
		});

		return userInformation;
	};

	this.loadAndSetUserGroups = function() {
		this.groups = (
			$.ajax({
				url: window.urlContext + 'company/groups',
				data: {id: this.companyId},
				type: 'POST',
				context: this,
				async: false
			}).responseJSON);

		this.setListData(this.groups, 'groups', true);
		this.setListData(this.groups, 'groups2', true);

		if (this.action == 'edit') {
			this.setUserRelation('group', this.user.groupId, this.groups);
		} else {
			this.userRelations.group = this.groups[0];
		}

		if (!_.isEmpty(this.userRelations.group)) {
			initDataInList(this.prefix + 'groups', this.userRelations.group.id);
			initDataInList(this.prefix + 'groups2', this.userRelations.group.id);
		}

		var user = this;
		$('#' + this.prefix + 'groups').change(function() {
			user.setUserRelation('group', getDataFromList(user.prefix + 'groups'), user.groups);
		});
	};

	this.setUserRelation = function(field, target, data) {
		this.userRelations[field] = _.filter(data, function(value) {
			return value['id'] == target;
		})[0];
	};


	this.individualPersonsType = function () {
		if (this.action === 'edit') {
			$('#new-user-li').hide();
		} else {
			$('#new-user-li').show();
		}
		this.isNewIndividualPerson = false;
		var _self = this;

		$('li#existed-user').click(function(){
			_self.isNewIndividualPerson = false;
			Swal.resetValidationMessage();
		});
		$('li#new-user-li').click(function(){
			_self.isNewIndividualPerson = true;
		});
	};

	this.saveIndividualPerson = function (data) {
		var url = 'user/createWithPerson';
		var user = this;

		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: JSON.stringify({
				'companyId': this.companyId,
				'individualPerson': data.individualPerson,
				'roleId': data.roleId,
				'groupId': data.groupId
			}),
			contentType: 'application/json; charset=UTF-8',

			success: function () {
				if (user.postSaveAction)
					user.postSaveAction();
				showMessageAlert(getLocalizedMessage("changes.saved"), 'success');
			},
			error: function (error) {
				console.log(error, error.responseText);
				showMessageAlert(getLocalizedMessage("error.saving"), 'danger', error.responseText);
			}
		});
	};

	this.initRemoveUserManager = function (user, activeAttribute) {
		var manager = this;

		Swal.fire({
			title: getLocalizedMessage('remove.confirmation'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					action: 'remove',
					activeAttribute: activeAttribute,
					user: user,
					companyId: manager.companyId,
					postRemoveAction: function() {
						table.initTable();
						table.selectedItemsManager.deleteRowMarkById(user.id);
					}
				});
			}
		}).then(function (result) {
			if (result.value) {
				manager.initRemovePage(false);
			}
		});
	};

	this.groupingUsers = function (ids, cb) {
		let manager = this
		let options = ''
		for (let i = 0; i < this.groups.length; i++) {
			options += '<option value="' + this.groups[i].id + '">' + this.groups[i].name + '</option>'
		}

		Swal.fire({
			title: getLocalizedMessage('grouping.users'),
			html: '<div class="modal_item">\n' +
				'    <label for="grouping_users">' + getLocalizedMessage('groups') + '</label>\n' +
				'    <br>\n' +
				'    <select id="grouping_users" class="select attribute-editor">\n' +
						options +
				'    </select>\n' +
				'</div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {

			},
			preConfirm: function () {
				return document.getElementById('grouping_users').value
			}
		}).then(function (result) {
			if (result.value) {
				manager.setUsersGroup(result.value, ids, cb)
			}
		});
	}

	this.setUsersGroup = function (groupId, ids, callback) {
		$.ajax({
			type: 'POST',
			url: window.urlContext + '/users/group',
			data: 'ids=[' + ids + ']&groupId=' + groupId,
			success: function (res) {
				showMessageAlert(getLocalizedMessage("changes.saved"), 'success');
				callback()
			}
		})
	}

	this.initRemoveUsersManager = function (ids) {
		var manager = this;

		Swal.fire({
			title: getLocalizedMessage('users.remove.confirmation'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					action: 'remove',
					companyId: manager.companyId,
					userIds: ids,
					postRemoveAction: function() {
						table.initTable();
						table.selectedItemsManager.clearSelections(table);
					}
				});
			}
		}).then(function (result) {
			if (result.value) {
				manager.initRemovePage(true);
			}
		});
	};
}
